// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"2921b275","613":"b7bbb2a9","787":"93c0ff9f"}[chunkId] + ".chunk.js";
};